import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import store from '../store'
import vm from '../main.js';

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home
    },
    //Auth
    {
        path: '/auth/login',
        name: 'Login',
        component: () => import('../views/Auth/Login.vue')
    },
    {
        path: '/auth/forgot',
        name: 'Forgot',
        component: () => import('../views/Auth/Forgot.vue')
    },
    {
        path: '/auth/forgotSuccess',
        name: 'ForgotSuccess',
        component: () => import('../views/Auth/ForgotSuccess.vue')
    },
    {
        path: '/auth/reset/:id',
        name: 'Reset',
        component: () => import('../views/Auth/Reset.vue')
    },
    //Admin
    {
        path: '/admin/courses',
        name: 'Courses',
        component: () => import('../views/Admin/Courses.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/admin/courses/:id',
        name: 'AdminCourseDetails',
        component: () => import('../views/Admin/CourseDetails.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/admin/users',
        name: 'AdminUsers',
        component: () => import('../views/Admin/Users.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/admin/coupons',
        name: 'AdminCoupons',
        component: () => import('../views/Admin/Coupons.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/admin/users/bulkEnrollment',
        name: 'AdminUsersBulkEnrollment',
        component: () => import('../views/Admin/UsersBulkEnrollment.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/admin/users/:id',
        name: 'AdminUsersDetails',
        component: () => import('../views/Admin/UsersDetails.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/admin/coursePackages',
        name: 'AdminCoursePackages',
        component: () => import('../views/Admin/CoursePackages.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/admin/coursePackages/:id',
        name: 'AdminCoursePackagesDetails',
        component: () => import('../views/Admin/CoursePackagesDetails.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/admin/sites',
        name: 'AdminSites',
        component: () => import('../views/Admin/Sites.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/admin/sites/:id',
        name: 'AdminSitesDetails',
        component: () => import('../views/Admin/SiteDetails.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/admin/payments',
        name: 'Payments',
        component: () => import('../views/Admin/Payments.vue'),
        meta: {
            requiresAuth: true
        }
    },
]

const router = new VueRouter({
    routes,
    scrollBehavior(to, from, savedPosition) {
        return { x: 0, y: 0 }
    }
})

router.beforeEach((to, from, next) => {
    // validate user logged in before allowing access
    var user = localStorage.getItem("userState");

    // make sure the user is authenticated
    if (!user) {
        store.commit("setUserState", null);

        // Avoid an infinite redirect
        if (to.name !== 'Login' && to.name !== 'Forgot' && to.name !== "ForgotSuccess" && to.name !== "Reset") {
            // redirect the user to the login page
            next('/auth/login');
        }
        else {
            next();
        }
    }
    else {
        if (to.name === 'Login') {
            // redirect the user to the home page
            next('/');
        }
        else {
            next();
        }
    }
    
});


export default router